var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"page-wrapper"},[(_vm.showHeader)?_c('Header',{attrs:{"data":_vm.$props}}):_vm._e(),_c('div',{staticClass:"main-content active-light-mode"},[_vm._t("default")],2),_c('Footer',{attrs:{"data":_vm.$props}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }